/* ==========================================================================
   LSC - Collage Collection: view toggle (created 16 Oct 2026, v6;
   v8 16 Oct 2026: view saved in the filters cookie; v14: scroll to top on
   switch; v15: allows for the header and nav bar as they settle)
   assets/lsc-collage-collection-view.js

   Loaded by sections/lsc-collage-collection.liquid only when "Show view
   toggle" is on, after assets/lsc-collage-collection-cookie.js.

   HOW VIEWS WORK
   Both views are in the page. The section root carries
   data-lsc-cc-view="collage|list", and the CSS shows the matching view and
   highlights the matching toggle button. This script only:
     1. switches that attribute when a toggle button is clicked;
     2. keeps aria-pressed on the toggle buttons in step with it;
     3. remembers the choice. LSC - v8: as lsc_view=collage|list inside the
        lsc_filters cookie, next to the saved filters (v6-v7 used its own
        lsc_cc_view cookie). The cookie helper's setView() keeps the
        filters as they are, and (v9) also keeps it in the tab's
        sessionStorage for when the cookie can't be written (theme editor
        preview, declined cookies: page 2 used to fall back to the
        default view there). The early inline script
        (snippets/lsc-collage-collection-early.liquid) applies the saved
        view on the next page before anything is drawn. No saved view =
        the section's "Default view" (Collage unless changed);
     4. fires "lsc-cc:viewchange" on document, detail { root, view }, so
        scripts that measure layout can re-measure. The carousel listens
        for it: a carousel set up while its view was hidden measured zero
        heights and needs re-fitting once it shows.
     5. LSC - v14 (16 Oct 2026): after a toggle click, scrolls back to the
        top of the section. The two views have very different heights (24
        collage rows are about 15,800px on desktop, the list a fraction of
        that), so a shopper who scrolled down the collage and switched to
        the list was left looking at the footer. Only scrolls when the top
        of the section is above the screen (someone still looking at the
        banner is not moved), and stops just below the theme's sticky
        header so the first products are not hidden under it. Instant, not
        smooth: the page under the shopper has just changed completely, so
        an animated scroll through it would only be noise.
        LSC - v15: the header and nav bar height is re-measured once the
        header has finished animating, and the position corrected; see
        scrollToTop().

   MARKUP IT EXPECTS
     [data-lsc-cc-toggle-root]     the section root (with data-lsc-cc-view)
       [data-lsc-cc-set-view="collage|list"]   the toggle buttons (v8: only
                                               on the floating bar)

   FILTERS
   The toggle sits outside #ProductGridContainer, which is what the theme's
   filter script replaces, so the chosen view survives every filter change
   without any work here.

   THEME EDITOR
   Re-scans on shopify:section:load; each root is set up once.
   ========================================================================== */
(function () {
  if (window.LscCcView) {
    window.LscCcView.scan();
    return;
  }

  var VIEWS = ['collage', 'list'];
  var Cookie = window.LscCcCookie; // may be missing if it failed to load

  /** Show `view` in `root`; save it when the shopper chose it. */
  function apply(root, view, remember) {
    root.setAttribute('data-lsc-cc-view', view);
    root.querySelectorAll('[data-lsc-cc-set-view]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-lsc-cc-set-view') === view ? 'true' : 'false');
    });
    if (remember && Cookie) Cookie.setView(view);
    document.dispatchEvent(new CustomEvent('lsc-cc:viewchange', { detail: { root: root, view: view } }));
  }

  // LSC - v15 (16 Oct 2026): the theme's top bars, i.e. the sections of
  // the header section group (announcement bar, header with its nav row).
  // Any of them can be sticky or fixed, depending on theme settings.
  var TOP_BARS = '.shopify-section-group-header-group';

  /** LSC - v15: how far down the screen the theme's top bars reach RIGHT
      NOW: the lowest bottom edge of any of them that is sticky or fixed,
      pinned at the top of the screen and visible. 0 when none is. */
  function coveredTop() {
    var bottom = 0;
    document.querySelectorAll(TOP_BARS).forEach(function (bar) {
      var cs = window.getComputedStyle(bar);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
      // The visible part of the bar: its inner header can be slid up out of
      // view (hide-on-scroll), which shows in the child's box, not the bar's.
      var r = bar.getBoundingClientRect();
      var inner = bar.querySelector('header');
      if (inner) r = inner.getBoundingClientRect();
      if (r.top > 1 || r.bottom <= 0) return; // not pinned at the top, or slid away
      bottom = Math.max(bottom, r.bottom);
    });
    return bottom;
  }

  /** LSC - v15: what the top bars WILL cover once the page has scrolled up
      to the section: the full height of every sticky or fixed bar, even
      one that is hidden at this moment (a hide-on-scroll header slides
      back in when the page scrolls up). Used for the first jump only. */
  function expectedCover() {
    var total = 0;
    document.querySelectorAll(TOP_BARS).forEach(function (bar) {
      var cs = window.getComputedStyle(bar);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      if (cs.display === 'none') return;
      total += bar.offsetHeight;
    });
    return total;
  }

  /** LSC - v14, v15: bring the top of the section back into view after a
      view switch (see the header, step 5), just below the theme's top bars
      (header and nav bar).
      v14 read the header's height once, at the click. That height is not
      stable: this theme animates the header (0.5s) between its full size
      at the top of the page and a shorter scrolled size, and can hide it
      while scrolling down and slide it back in on the way up, so a reading
      taken mid-change left the first products under the nav bar. v15:
        1. jumps using the full height the bars will have once shown;
        2. after the header has finished animating (600ms), measures what
           actually covers the top of the screen and nudges the page so the
           section starts exactly below it.
      Step 2 is skipped if the shopper scrolls, touches or presses a key in
      the meantime, so it never fights them. */
  function scrollToTop(root) {
    var top = root.getBoundingClientRect().top; // relative to the screen
    if (top >= coveredTop()) return; // the section's top is already in view
    var target = window.pageYOffset + top - expectedCover();
    window.scrollTo({ top: Math.max(0, target), behavior: 'auto' });

    var cancelled = false;
    var cancel = function () { cancelled = true; };
    var events = ['wheel', 'touchstart', 'keydown'];
    events.forEach(function (name) {
      window.addEventListener(name, cancel, { once: true, passive: true });
    });
    window.setTimeout(function () {
      events.forEach(function (name) {
        window.removeEventListener(name, cancel);
      });
      if (cancelled) return;
      var offBy = root.getBoundingClientRect().top - coveredTop();
      // Only small corrections (the bars' height); anything bigger means the
      // page moved for another reason, so leave it alone.
      if (Math.abs(offBy) > 1 && Math.abs(offBy) < 300) {
        window.scrollBy({ top: offBy, behavior: 'auto' });
      }
    }, 600);
  }

  /** Per section: sync the buttons, then handle clicks. */
  function setup(root) {
    if (root.__lscCcView) return;
    root.__lscCcView = true;

    var current = root.getAttribute('data-lsc-cc-view');
    if (VIEWS.indexOf(current) === -1) current = 'collage';
    apply(root, current, false);

    // A remembered view is re-written on each visit, which keeps the cookie
    // alive past browser expiry caps (see the cookie helper).
    if (Cookie && Cookie.getView()) Cookie.setView(current);

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lsc-cc-set-view]');
      if (!button || !root.contains(button)) return;
      var view = button.getAttribute('data-lsc-cc-set-view');
      if (VIEWS.indexOf(view) === -1 || view === root.getAttribute('data-lsc-cc-view')) return;
      apply(root, view, true);
      scrollToTop(root); // v14: the new view starts at its first product
    });
  }

  function scan() {
    document.querySelectorAll('[data-lsc-cc-toggle-root]').forEach(setup);
  }

  document.addEventListener('shopify:section:load', scan);

  window.LscCcView = { scan: scan };
  scan();
})();
